import React from 'react';
import { Person, PersonPermission } from 'nekst-api';
import { Button, ButtonColor, ButtonSize, usePopupManager } from 'ui-builder';
import useAuthorizationChecker from '../../shared/authorization/authorizationChecker';
import useResendInvitationService from './resendInvitationService';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';

function ResendInvitationPopup(
  props: {
    person: Person,
  },
) {
  const message = `By clicking "Confirm", the invitation email will be sent to ${props.person.profile.name.fullName}.`;

  const service = useResendInvitationService();

  return (
    <ConfirmPositiveActionPopup
      title="Resend Invitation Email"
      message={message}
      submitFormFunc={async () => service.resendInvitation(props.person.id)}
    />
  );
}

export default function ResendInvitationButton(
  props: {
    person: Person,
  },
) {
  const { isGranted } = useAuthorizationChecker();

  const popupManager = usePopupManager();

  if (isGranted(PersonPermission.SEND_INVITATION)) {

    const isDisabled = !props.person._user.canInvitationBeResent;
    return (
      <Button
        color={ButtonColor.BLUE}
        isFilled
        size={ButtonSize.MEDIUM}
        text="Re-send invitation"
        isDisabled={isDisabled}
        title={
          isDisabled
            ? 'It\'s not possible to send invitations more often than once in an hour'
            : undefined
        }
        onClick={() => popupManager.openPopup(<ResendInvitationPopup person={props.person} />)}
      />
    );
  } else {
    return null;
  }
}
